<select
  id="ticker-selector"
  [(ngModel)]="selectedTicker"
  (ngModelChange)="tickerChange()"
  [disabled]="tickerList.length == 1"
>
  <ng-container *ngFor="let ticker of tickerList">
    <option [ngValue]="ticker">{{ ticker.name }}</option>
  </ng-container>
</select>
<div id="line-item-search">
  <nz-input-group [nzPrefix]="prefixIcon">
    <input
      id="search-box"
      #searchbox
      placeholder="Search line items"
      nz-input
      [formControl]="queryField"
      [nzAutocomplete]="auto"
    />
  </nz-input-group>
  <ng-template #prefixIcon>
    <va-icon size="small" name="search" class="fa-md search-icon"></va-icon>
  </ng-template>
  <nz-autocomplete #auto>
    <nz-auto-optgroup *ngFor="let group of optionGroups" [nzLabel]="groupTitle">
      <ng-template #groupTitle>
        <span class="line-item-group">{{ group.title }} </span>
      </ng-template>
      <nz-auto-option
        *ngFor="let option of group.children"
        (click)="onSelectLineItem(option)"
        [nzLabel]="option.title"
        [nzValue]="option.title"
        class="line-item-child"
      >
        <span
          [innerHtml]="option.title | textHighlight: searchbox.value"
        ></span>
      </nz-auto-option>
    </nz-auto-optgroup>
  </nz-autocomplete>
</div>
